import { Map } from "immutable"

import {
    STUDIO_BRIEFING_EMAIL_CANCEL,
    STUDIO_BRIEFING_EMAIL_ERROR_RESPONSE,
    STUDIO_BRIEFING_EMAIL_MODEL_UPDATE,
    STUDIO_BRIEFING_EMAIL_REQUEST,
    STUDIO_BRIEFING_EMAIL_RESPONSE,
    STUDIO_BRIEFING_ERROR_RESPONSE,
    STUDIO_BRIEFING_REQUEST,
    STUDIO_BRIEFING_RESPONSE,
    STUDIO_CLONE_MAP,
    STUDIO_CREATE_DIMENSION_APPLY_MODEL_UPDATE,
    STUDIO_CREATE_DIMENSION_CANCEL,
    STUDIO_CREATE_DIMENSION_SAVE_RESPONSE,
    STUDIO_CREATE_DIMENSION_UPDATE_MODEL,
    STUDIO_DIMENSION_ITEM_REQUEST,
    STUDIO_DIMENSION_ITEM_RESPONSE,
    STUDIO_DIMENSION_WIZARD_REQUEST,
    STUDIO_DIMENSION_WIZARD_RESPONSE,
    STUDIO_DOWNLOAD_IMAGE_ERROR_RESPONSE,
    STUDIO_DOWNLOAD_IMAGE_REQUEST,
    STUDIO_DOWNLOAD_IMAGE_RESPONSE,
    STUDIO_EDIT_ADD_KEY_ISSUES_REQUEST,
    STUDIO_EDIT_ADD_KEY_ISSUES_RESPONSE,
    STUDIO_EDIT_APPLY_MODEL_UPDATE,
    STUDIO_EDIT_CANCEL_MODEL_UPDATE,
    STUDIO_EDIT_CLEAR_KEY_ISSUES,
    STUDIO_EDIT_COPY_IMAGE_URL,
    STUDIO_EDIT_DESELECT_TOPIC,
    STUDIO_EDIT_DIMENSIONS_LIST_COUNT_REQUEST,
    STUDIO_EDIT_DIMENSIONS_LIST_COUNT_RESPONSE,
    STUDIO_EDIT_DIMENSIONS_LIST_REQUEST,
    STUDIO_EDIT_DIMENSIONS_LIST_RESPONSE,
    STUDIO_EDIT_KEY_ISSUE_DRAG_END,
    STUDIO_EDIT_KEY_ISSUE_DRAG_START,
    STUDIO_EDIT_RELATED_DIMENSIONS_LIST_REQUEST,
    STUDIO_EDIT_RELATED_DIMENSIONS_LIST_RESPONSE,
    STUDIO_EDIT_REMOVE_KEY_ISSUE,
    STUDIO_EDIT_SELECT_TAB,
    STUDIO_EDIT_TOGGLE_IMAGE_UPLOAD_MODAL,
    STUDIO_EDIT_TOPICS_LIST_COUNT_REQUEST,
    STUDIO_EDIT_TOPICS_LIST_COUNT_RESPONSE,
    STUDIO_EDIT_TOPICS_LIST_REQUEST,
    STUDIO_EDIT_TOPICS_LIST_RESPONSE,
    STUDIO_EDIT_TOPIC_DIMENSION_SEARCH,
    STUDIO_EDIT_UPDATE_IMAGE,
    STUDIO_EDIT_UPDATE_MODEL,
    STUDIO_HIGHLIGHT_DIMENSION,
    STUDIO_HIGHLIGHT_DIMENSION_NEXT,
    STUDIO_HIGHLIGHT_DIMENSION_PREVIOUS,
    STUDIO_HIGHLIGHT_TOPIC,
    STUDIO_ITEM_CACHED_RESPONSE,
    STUDIO_ITEM_DELETE_ERROR_RESPONSE,
    STUDIO_ITEM_DELETE_REQUEST,
    STUDIO_ITEM_DELETE_RESPONSE,
    STUDIO_ITEM_ERROR_RESPONSE,
    STUDIO_ITEM_REQUEST,
    STUDIO_ITEM_RESPONSE,
    STUDIO_ITEM_SAVE_ERROR_RESPONSE,
    STUDIO_ITEM_SAVE_REQUEST,
    STUDIO_ITEM_SAVE_RESPONSE,
    STUDIO_KNOWLEDGE_ITEM_REQUEST,
    STUDIO_KNOWLEDGE_ITEM_RESPONSE,
    STUDIO_KNOWLEDGE_LIST_REQUEST,
    STUDIO_KNOWLEDGE_LIST_RESPONSE,
    STUDIO_KNOWLEDGE_DATA_LIST_REQUEST,
    STUDIO_KNOWLEDGE_DATA_LIST_RESPONSE,
    STUDIO_LIST_CACHED_RESPONSE,
    STUDIO_LIST_ERROR_RESPONSE,
    STUDIO_LIST_REQUEST,
    STUDIO_LIST_RESPONSE,
    STUDIO_LIST_SEARCH_REQUEST,
    STUDIO_LIST_TYPE_CHANGE,
    STUDIO_NEW_MAP,
    STUDIO_PROJECTS_LIST_REQUEST,
    STUDIO_PROJECTS_LIST_RESPONSE,
    STUDIO_REPORTS_LIST_REQUEST,
    STUDIO_REPORTS_LIST_RESPONSE,
    STUDIO_SESSIONS_LIST_REQUEST,
    STUDIO_SESSIONS_LIST_RESPONSE,
    STUDIO_STAKEHOLDERS_LIST_REQUEST,
    STUDIO_STAKEHOLDERS_LIST_RESPONSE,
    STUDIO_TOGGLE_BRIEFING_EMAIL_MODAL,
    STUDIO_TOGGLE_IMAGE_SETTINGS_MODAL,
    STUDIO_SHOW_INTERACTIVE_DATA,
    STUDIO_HIDE_INTERACTIVE_DATA
} from "./action-types"
import {
    itemRequest,
    itemResponse,
    itemCachedResponse,
    itemErrorResponse,
    itemSaveRequest,
    itemSaveErrorResponse,
    itemDeleteRequest,
    itemDeleteResponse
} from "./default-actions/entity-actions"
import {
    listPageRequest,
    listSearchRequest,
    listResponse as presentationListResponse,
    itemRequest as presentationItemRequest,
    itemResponse as presentationItemResponse,
    updateModel,
    updateImage,
    cancelModelUpdate,
    applyModelUpdate,
    defaultAction
} from "./default-actions/presentation-actions"
import {
    listRequest,
    listResponse,
    listCachedResponse,
    listErrorResponse
} from "./default-actions/paging-actions"
import { defaultAllTopicTypes } from "../config/application-definitions"

// Paging Actions
const defaultListRequestCreator = listRequest(STUDIO_LIST_REQUEST)
export const studioListRequest = pagingRequest => {
    const defaultListRequestAction = defaultListRequestCreator(pagingRequest)
    return {
        ...defaultListRequestAction,
        limit: 42
    }
}
export const studioListSearchRequest = listSearchRequest(
    STUDIO_LIST_SEARCH_REQUEST
)
export const studioListTypeChange = (type, pagingRequest) => ({
    type: STUDIO_LIST_TYPE_CHANGE,
    topicType: type,
    pagingRequest
})
export const studioListResponse = listResponse(STUDIO_LIST_RESPONSE)
export const studioListCachedResponse = listCachedResponse(
    STUDIO_LIST_CACHED_RESPONSE
)
export const studioListErrorResponse = listErrorResponse(
    STUDIO_LIST_ERROR_RESPONSE
)

// Entity Request/Response Actions
export const studioItemRequest = itemRequest(STUDIO_ITEM_REQUEST)
export const studioItemResponse = itemResponse(STUDIO_ITEM_RESPONSE)
export const studioItemErrorResponse = itemErrorResponse(
    STUDIO_ITEM_ERROR_RESPONSE
)
export const studioItemCachedResponse = itemCachedResponse(
    STUDIO_ITEM_CACHED_RESPONSE
)
export const studioItemSaveRequest = itemSaveRequest(STUDIO_ITEM_SAVE_REQUEST)
export const studioItemSaveErrorResponse = itemSaveErrorResponse(
    STUDIO_ITEM_SAVE_ERROR_RESPONSE
)
export const studioItemSaveResponse = itemResponse(STUDIO_ITEM_SAVE_RESPONSE)
export const studioItemDeleteRequest = itemDeleteRequest(
    STUDIO_ITEM_DELETE_REQUEST
)
export const studioItemDeleteResponse = itemDeleteResponse(
    STUDIO_ITEM_DELETE_RESPONSE
)
export const studioItemDeleteErrorResponse = itemErrorResponse(
    STUDIO_ITEM_DELETE_ERROR_RESPONSE
)

// Interaction Actions
export const studioEditUpdateModel = updateModel(STUDIO_EDIT_UPDATE_MODEL)
export const studioEditUpdateImage = updateImage(STUDIO_EDIT_UPDATE_IMAGE)
export const studioEditCopyImageUrl = imageUrl => ({
    type: STUDIO_EDIT_COPY_IMAGE_URL,
    imageUrl
})
export const studioEditApplyModelUpdate = applyModelUpdate(
    STUDIO_EDIT_APPLY_MODEL_UPDATE
)
export const studioEditCancelModelUpdate = cancelModelUpdate(
    STUDIO_EDIT_CANCEL_MODEL_UPDATE
)

export const studioHighlightDimension = id => ({
    type: STUDIO_HIGHLIGHT_DIMENSION,
    id
})

export const studioHighlightDimensionNext = defaultAction(
    STUDIO_HIGHLIGHT_DIMENSION_NEXT
)
export const studioHighlightDimensionPrevious = defaultAction(
    STUDIO_HIGHLIGHT_DIMENSION_PREVIOUS
)
export const studioHighlightTopic = defaultAction(STUDIO_HIGHLIGHT_TOPIC)

export const studioCloneMap = defaultAction(STUDIO_CLONE_MAP)
export const studioNewMap = defaultAction(STUDIO_NEW_MAP)

export const studioShowInteractiveData = interactiveLink => ({
    type: STUDIO_SHOW_INTERACTIVE_DATA,
    interactiveLink
})
export const studioHideInteractiveData = defaultAction(
    STUDIO_HIDE_INTERACTIVE_DATA
)

export const studioBriefingEmailModelUpdate = updateModel(
    STUDIO_BRIEFING_EMAIL_MODEL_UPDATE
)
export const studioBriefingEmailCancel = cancelModelUpdate(
    STUDIO_BRIEFING_EMAIL_CANCEL
)
export const studioBriefingEmailRequest = itemSaveRequest(
    STUDIO_BRIEFING_EMAIL_REQUEST
)
export const studioBriefingEmailResponse = itemResponse(
    STUDIO_BRIEFING_EMAIL_RESPONSE
)
export const studioBriefingEmailErrorResponse = itemSaveErrorResponse(
    STUDIO_BRIEFING_EMAIL_ERROR_RESPONSE
)

export const studioToggleBriefingEmailModal = defaultAction(
    STUDIO_TOGGLE_BRIEFING_EMAIL_MODAL
)

// Image Actions
export const studioToggleImageSettingsModal = defaultAction(
    STUDIO_TOGGLE_IMAGE_SETTINGS_MODAL
)
export const studioDownloadImageRequest = (id, queryParams) => ({
    type: STUDIO_DOWNLOAD_IMAGE_REQUEST,
    id,
    queryParams
})
export const studioDownloadImageResponse = itemResponse(
    STUDIO_DOWNLOAD_IMAGE_RESPONSE
)
export const studioDownloadImageErrorResponse = code => ({
    type: STUDIO_DOWNLOAD_IMAGE_ERROR_RESPONSE,
    code
})

export const studioEditSelectTab = tab => ({
    type: STUDIO_EDIT_SELECT_TAB,
    tab
})

export const studioEditTopicDimensionSearch = searchTerm => ({
    type: STUDIO_EDIT_TOPIC_DIMENSION_SEARCH,
    searchTerm
})

export const studioEditDeselectTopic = defaultAction(STUDIO_EDIT_DESELECT_TOPIC)

export const studioEditRemoveKeyIssue = dimensionId => ({
    type: STUDIO_EDIT_REMOVE_KEY_ISSUE,
    dimensionId
})

export const studioEditClearKeyIssues = defaultAction(
    STUDIO_EDIT_CLEAR_KEY_ISSUES
)

export const studioEditAddKeyIssuesRequest = (dimensionIds, topicId) => ({
    type: STUDIO_EDIT_ADD_KEY_ISSUES_REQUEST,
    dimensionIds,
    topicId
})

export const studioEditAddKeyIssuesResponse = (dimensionActions, topicId) => ({
    type: STUDIO_EDIT_ADD_KEY_ISSUES_RESPONSE,
    dimensionActions,
    topicId
})

export const studioEditKeyIssueDragStart = defaultAction(
    STUDIO_EDIT_KEY_ISSUE_DRAG_START
)

export const studioEditKeyIssueDragEnd = defaultAction(
    STUDIO_EDIT_KEY_ISSUE_DRAG_END
)

export const studioEditToggleImageUploadModal = defaultAction(
    STUDIO_EDIT_TOGGLE_IMAGE_UPLOAD_MODAL
)

// Studio Extra Data Actions
export const studioBriefingRequest = id => ({
    type: STUDIO_BRIEFING_REQUEST,
    id
})

export const studioBriefingResponse = defaultAction(STUDIO_BRIEFING_RESPONSE)

export const studioBriefingErrorResponse = code => ({
    type: STUDIO_BRIEFING_ERROR_RESPONSE,
    code
})

export const studioDimensionWizardRequest = defaultAction(
    STUDIO_DIMENSION_WIZARD_REQUEST
)

export const studioDimensionWizardResponse = presentationItemResponse(
    STUDIO_DIMENSION_WIZARD_RESPONSE
)

export const studioCreateDimensionUpdateModel = updateModel(
    STUDIO_CREATE_DIMENSION_UPDATE_MODEL
)
export const studioCreateDimensionApplyModelUpdate = applyModelUpdate(
    STUDIO_CREATE_DIMENSION_APPLY_MODEL_UPDATE
)
export const studioCreateDimensionSaveResponse = presentationItemResponse(
    STUDIO_CREATE_DIMENSION_SAVE_RESPONSE
)
export const studioCreateDimensionCancel = defaultAction(
    STUDIO_CREATE_DIMENSION_CANCEL
)

const studioEditRelatedDimensionsListResponse = presentationListResponse(
    STUDIO_EDIT_RELATED_DIMENSIONS_LIST_RESPONSE
)
const defaultStudioEditRelatedDimensionsListRequest = listPageRequest(
    STUDIO_EDIT_RELATED_DIMENSIONS_LIST_REQUEST,
    studioEditRelatedDimensionsListResponse
)
export const studioEditRelatedDimensionsListRequest = (
    pagingRequest,
    topicId
) => ({
    ...defaultStudioEditRelatedDimensionsListRequest(pagingRequest),
    topicId
})

export const studioDimensionItemRequest = presentationItemRequest(
    STUDIO_DIMENSION_ITEM_REQUEST
)
export const studioDimensionItemResponse = presentationItemResponse(
    STUDIO_DIMENSION_ITEM_RESPONSE
)

const studioKnowledgeListResponse = presentationListResponse(
    STUDIO_KNOWLEDGE_LIST_RESPONSE
)
const defaultStudioKnowledgeListRequest = listPageRequest(
    STUDIO_KNOWLEDGE_LIST_REQUEST,
    studioKnowledgeListResponse
)
export const studioKnowledgeListRequest = (
    pagingRequest,
    highlightedId,
    isViewingTopic,
    publicationType
) => ({
    ...defaultStudioKnowledgeListRequest(pagingRequest),
    highlightedId,
    isViewingTopic,
    publicationType
})
export const studioKnowledgeItemRequest = presentationItemRequest(
    STUDIO_KNOWLEDGE_ITEM_REQUEST
)
export const studioKnowledgeItemResponse = presentationItemResponse(
    STUDIO_KNOWLEDGE_ITEM_RESPONSE
)

const studioStakeholdersListResponse = presentationListResponse(
    STUDIO_STAKEHOLDERS_LIST_RESPONSE
)
const defaultStudioStakeholdersListRequest = listPageRequest(
    STUDIO_STAKEHOLDERS_LIST_REQUEST,
    studioStakeholdersListResponse
)
export const studioStakeholdersListRequest = (
    pagingRequest,
    highlightedId,
    isViewingTopic,
    filteredRole
) => ({
    ...defaultStudioStakeholdersListRequest(pagingRequest),
    isViewingTopic,
    highlightedId,
    filteredRole
})

const studioSessionsListResponse = presentationListResponse(
    STUDIO_SESSIONS_LIST_RESPONSE
)
const defaultStudioSessionsListRequest = listPageRequest(
    STUDIO_SESSIONS_LIST_REQUEST,
    studioSessionsListResponse
)
export const studioSessionsListRequest = (
    pagingRequest,
    highlightedId,
    isViewingTopic
) => ({
    ...defaultStudioSessionsListRequest(pagingRequest),
    isViewingTopic,
    highlightedId
})

const studioProjectsListResponse = presentationListResponse(
    STUDIO_PROJECTS_LIST_RESPONSE
)
const defaultStudioProjectsListRequest = listPageRequest(
    STUDIO_PROJECTS_LIST_REQUEST,
    studioProjectsListResponse
)
export const studioProjectsListRequest = (
    pagingRequest,
    highlightedId,
    isViewingTopic
) => ({
    ...defaultStudioProjectsListRequest(pagingRequest),
    isViewingTopic,
    highlightedId
})

const studioReportsListResponse = presentationListResponse(
    STUDIO_REPORTS_LIST_RESPONSE
)
const defaultStudioReportsListRequest = listPageRequest(
    STUDIO_REPORTS_LIST_REQUEST,
    studioReportsListResponse
)
export const studioReportsListRequest = (
    pagingRequest,
    highlightedId,
    isViewingTopic
) => ({
    ...defaultStudioReportsListRequest(pagingRequest),
    isViewingTopic,
    highlightedId
})

const studioKnowledgeDataListResponse = presentationListResponse(
    STUDIO_KNOWLEDGE_DATA_LIST_RESPONSE
)
const defaultStudioKnowledgeDataListRequest = listPageRequest(
    STUDIO_KNOWLEDGE_DATA_LIST_REQUEST,
    studioKnowledgeDataListResponse
)
export const studioKnowledgeDataListRequest = (
    pagingRequest,
    highlightedId,
    isViewingTopic
) => ({
    ...defaultStudioKnowledgeDataListRequest(pagingRequest),
    isViewingTopic,
    highlightedId
})

const studioEditTopicsListResponse = presentationListResponse(
    STUDIO_EDIT_TOPICS_LIST_RESPONSE
)
const defaultStudioEditTopicsListRequest = listPageRequest(
    STUDIO_EDIT_TOPICS_LIST_REQUEST,
    studioEditTopicsListResponse
)
export const studioEditTopicsListRequest = pagingRequest =>
    addDefaultTopicTypes(
        addActiveStatus(defaultStudioEditTopicsListRequest(pagingRequest))
    )
const studioEditTopicsListCountResponse = presentationListResponse(
    STUDIO_EDIT_TOPICS_LIST_COUNT_RESPONSE
)
const defaultStudioEditTopicsListCountRequest = listPageRequest(
    STUDIO_EDIT_TOPICS_LIST_COUNT_REQUEST,
    studioEditTopicsListCountResponse
)
export const studioEditTopicsListCountRequest = pagingRequest =>
    addDefaultTopicTypes(
        addActiveStatus(defaultStudioEditTopicsListCountRequest(pagingRequest))
    )
const studioEditDimensionsListResponse = presentationListResponse(
    STUDIO_EDIT_DIMENSIONS_LIST_RESPONSE
)
const defaultStudioEditDimensionsListRequest = listPageRequest(
    STUDIO_EDIT_DIMENSIONS_LIST_REQUEST,
    studioEditDimensionsListResponse
)
export const studioEditDimensionsListRequest = pagingRequest =>
    addHasParent(
        addActiveStatus(defaultStudioEditDimensionsListRequest(pagingRequest))
    )
const studioEditDimensionsListCountResponse = presentationListResponse(
    STUDIO_EDIT_DIMENSIONS_LIST_COUNT_RESPONSE
)
const defaultStudioEditDimensionsListCountRequest = listPageRequest(
    STUDIO_EDIT_DIMENSIONS_LIST_COUNT_REQUEST,
    studioEditDimensionsListCountResponse
)
export const studioEditDimensionsListCountRequest = pagingRequest =>
    addHasParent(
        addActiveStatus(
            defaultStudioEditDimensionsListCountRequest(pagingRequest)
        )
    )

function addHasParent(action) {
    return {
        ...action,
        searchCriteria: (action.searchCriteria || Map()).set("has_parent", true)
    }
}

function addActiveStatus(action) {
    return {
        ...action,
        searchCriteria: (action.searchCriteria || Map())
            .set("statuses", "Active")
    }
}

function addDefaultTopicTypes(action) {
    return {
        ...action,
        searchCriteria: (action.searchCriteria || Map())
            .set("types", defaultAllTopicTypes.map(({ name }) => name))
    }
}
